import type { HelpFile } from '../../types/help'
import { SchemaPolicyEditTestIds } from '../../../testids/SchemaPolicyEditTestIds'

export const schemaPolicyEditHelp: HelpFile = {
  docPage: '/docs/schema/policies',
  texts: {
    [SchemaPolicyEditTestIds.schemaPolicyEdit]:
      'Schema-Richtlinie erstellen oder bearbeiten — CEL-Ausdruck gegen Parties / Identitäten ausgewertet oder ein registrierter Native-Code-Producer.',
    [SchemaPolicyEditTestIds.inputName]:
      'Global eindeutiger kebab-case-Slug — erscheint in der Verstoßliste und als Richtlinien-Referenz.',
    [SchemaPolicyEditTestIds.inputDescription]:
      'Kurze Beschreibung der Invariante, die die Richtlinie durchsetzt. Reiner Fließtext, ohne Auszeichnung.',
    [SchemaPolicyEditTestIds.selectType]:
      'DSL wertet den CEL-Ausdruck zur Erkennungszeit aus. NATIVE_CODE delegiert an einen registrierten Java-Producer (z. B. Roh-SQL oder andere native Logik).',
    [SchemaPolicyEditTestIds.inputExpression]:
      'CEL-Ausdruck — unterstützt party.* / identity.* Roots, Attributreferenzen, `== null` / `!= null`, Vergleichs- und Logikoperatoren (`&&`, `||`, `!`).',
    [SchemaPolicyEditTestIds.inputConstraintCode]:
      'Für NATIVE_CODE-Richtlinien — der Bean-Schlüssel, der zu @Component(producerCode = "…") passt.',
    [SchemaPolicyEditTestIds.selectSeverity]:
      'Bestimmt Badge-Farbe und Reihenfolge in Verstoßlisten. INFO / WARN / ERROR / CRITICAL.',
    [SchemaPolicyEditTestIds.inputMessageTemplate]:
      'Pro Zeile gerenderte Verstoßmeldung. Platzhalter {displayName}, {subjectId}, {constraintName} werden ersetzt.',
    [SchemaPolicyEditTestIds.btnSave]: 'Richtlinie speichern. Neu erstellte Richtlinien sind initial deaktiviert — explizit auf der Detailseite aktivieren.',
    [SchemaPolicyEditTestIds.btnCancel]: 'Änderungen verwerfen und zur Richtlinienliste zurückkehren.',
  },
}
